import React, { Component } from 'react';

class Resume extends Component {
  render() {

    if (this.props.data) {
      var skillmessage = this.props.data.skillmessage;
      var education = this.props.data.education.map(function (education) {
        return <div key={education.school}><h3>{education.school}</h3>
          <p className="info">{education.degree} <span>&bull;</span>{education.major}<span>&bull;</span><em className="date">{education.graduated}</em></p>
          <p>{education.description}</p></div>
      })
      var work = this.props.data.work.map(function (work) {
        return <div key={work.company}><h3>{work.company}</h3>
          <p style={{marginBottom: 5}}>{work.employer}</p>
          <p className="info">{work.title}<span>&bull;</span> <em className="date">{work.years}</em></p>
          <p>{work.description}</p>
        </div>
      })
      var skills = this.props.data.skills.map(function (skills) {
        var skillsImage = 'images/portfolio/' + skills.image;
        var className = 'bar-expand ' + skills.name.toLowerCase();
        return <li key={skills.name}><span style={{ width: skills.level }} className={className}><span className='skillsPerc'>{skills.level}</span></span>
          <em id="skillsDesc">
            <img id="skillsLogo" alt={skills.name} src={skillsImage} />
            <p id="skillsName">{skills.name}</p>
          </em>
        </li>
      })
      var certifications = this.props.data.certifications.map(function (certifications) {
        var certificationImage = 'images/portfolio/' + certifications.image;
        return <div key={certifications.name}><h3>{certifications.name}</h3>
          <div id="certificationDesc">
            <img id="certificationLogo" alt={certifications.name} src={certificationImage} />
            <p id="certificateName">{certifications.provider}</p>
          </div>
          <p className="acquired">Acquired - {certifications.acquired}</p>
        </div>
      })
    }

    return (
      <section id="resume">

        <div className="row education">
          <div className="three columns header-col">
            <h1><span>Education</span></h1>
          </div>

          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                {education}
              </div>
            </div>
          </div>
        </div>


        <div className="row work">
          <div className="three columns header-col">
            <h1><span>Work Experience</span></h1>
          </div>

          <div className="nine columns main-col">
            {work}
          </div>
        </div>


        <div className="row certificate">
          <div className="three columns header-col">
            <h1><span>Certification</span></h1>
          </div>

          <div className="nine columns main-col">
            {certifications}
          </div>
        </div>


        <div className="row skill">

          <div className="three columns header-col">
            <h1><span>Skills</span></h1>
          </div>

          <div className="nine columns main-col">

            <div className="bars">
              <ul className="skills">
                {skills}
              </ul>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Resume;
